import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildSignedInDocPathRedirectTo } from '../utils/documentLinks';

/**
 * `/doc/:documentId` is not a viewer route (only `/doc/:id/fill` is).
 * Send it to the canonical signed-in opener `/?doc=` so KnowledgeBaseUserView
 * can load the document the same way a query-param deep link does.
 */
export default function DocPathRedirect() {
  const { documentId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={buildSignedInDocPathRedirectTo(documentId, location.search, location.hash)}
      replace
    />
  );
}
